import "./OurBenefits.scss";

import BenefitIcon1 from "../../assets/images/benefit-1.png";
import BenefitIcon2 from "../../assets/images/benefit-2.png";
import BenefitIcon3 from "../../assets/images/benefit-3.png";

export default function OurBenefits() {
	return (
		<div className="our-benefits" id="features">
			<div className="our-benefits-content content-wrapper-lg">
				<h3 className="our-benefits-title" data-aos="zoom-in">
					Choose Iris
				</h3>
				<div className="our-benefits-desc" data-aos="fade-up" data-aos-delay="50">
					Empowering your future with intelligent, autonomous agents
					for a smarter, more secure world of endless potential.
				</div>

				<ul className="benefits">
					<li className="benefit" data-aos="zoom-in" data-aos-delay="100">
						<div className="benefit-card">
							<div className="benefit-icon">
								<img src={BenefitIcon1} alt="Benefit Icon" />
							</div>
							<div className="benefit-title">
								Autonomous Intelligence
							</div>
							<div className="benefit-desc">
								Iris Al agents learn, adapt, and act
								independently, delivering smarter solutions with
								minimal oversight.
							</div>
						</div>
					</li>

					<li className="benefit" data-aos="zoom-in" data-aos-delay="300">
						<div className="benefit-card">
							<div className="benefit-icon">
								<img src={BenefitIcon2} alt="Benefit Icon" />
							</div>
							<div className="benefit-title">
								Optimized Performance
							</div>
							<div className="benefit-desc">
								Unlock advanced AI capabilities tailored to
								deliver precision, speed, and effortless
								integration for every need.
							</div>
						</div>
					</li>

					<li className="benefit" data-aos="zoom-in" data-aos-delay="500">
						<div className="benefit-card">
							<div className="benefit-icon">
								<img src={BenefitIcon3} alt="Benefit Icon" />
							</div>
							<div className="benefit-title">
								Enhanced AI Integration
							</div>
							<div className="benefit-desc">
								Easily incorporate Iris Al into your workflows,
								enhancing efficiency with intelligent, adaptive
								capabilities.
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
}
